import { PROFILE_PHOTO_LOCAL_MARKER } from "./playerProfileConstants";

/**
 * Fields counted toward completion (v1 profile editor).
 * @type {Array<{ id: string; label: string; isComplete: (player: Record<string, unknown>, hasLocalPhoto: boolean) => boolean }>}
 */
export const PROFILE_COMPLETION_CHECKS = [
  {
    id: "displayName",
    label: "Display name",
    isComplete: (p) => Boolean((p.displayName || "").trim()),
  },
  {
    id: "firstName",
    label: "First name",
    isComplete: (p) => Boolean((p.firstName || "").trim()),
  },
  {
    id: "lastName",
    label: "Last name",
    isComplete: (p) => Boolean((p.lastName || "").trim()),
  },
  {
    id: "profilePhoto",
    label: "Photo",
    isComplete: (p, hasLocalPhoto) =>
      hasLocalPhoto ||
      (typeof p.profilePhoto === "string" &&
        p.profilePhoto.trim() !== "" &&
        p.profilePhoto !== PROFILE_PHOTO_LOCAL_MARKER),
  },
  {
    id: "preferredHand",
    label: "Preferred hand",
    isComplete: (p) => p.preferredHand === "Left" || p.preferredHand === "Right",
  },
  {
    id: "city",
    label: "City",
    isComplete: (p) => Boolean((p.city || "").trim()),
  },
  {
    id: "country",
    label: "Country",
    isComplete: (p) =>
      Boolean(String(p.countryIso || "").trim()) || Boolean((p.country || "").trim()),
  },
  {
    id: "gender",
    label: "Gender",
    isComplete: (p) => Boolean((p.gender || "").trim()),
  },
  {
    id: "contactEmail",
    label: "Email",
    isComplete: (p) => Boolean((p.contactEmail || "").trim()),
  },
  {
    id: "phone",
    label: "Phone",
    isComplete: (p) => Boolean((p.phoneNationalNumber || "").trim()),
  },
  {
    id: "bio",
    label: "Bio",
    isComplete: (p) => Boolean((p.bio || "").trim()),
  },
];

/**
 * @param {Record<string, unknown>} player
 * @param {{ hasLocalPhoto?: boolean }} [options]
 * @returns {{ percentage: number; items: Array<{ id: string; label: string; complete: boolean }> }}
 */
export function calculateProfileCompletion(player, options = {}) {
  const hasLocalPhoto = Boolean(options.hasLocalPhoto);
  const items = PROFILE_COMPLETION_CHECKS.map((check) => ({
    id: check.id,
    label: check.label,
    complete: check.isComplete(player, hasLocalPhoto),
  }));
  const total = items.length;
  const done = items.filter((i) => i.complete).length;
  const percentage = total === 0 ? 0 : Math.round((done / total) * 100);
  return { percentage, items };
}
